__turbopack_context__.v({
  "actionsNav": "CompareCarousel-module-scss-module__uDSTdG__actionsNav",
  "compareCarouselWrapper": "CompareCarousel-module-scss-module__uDSTdG__compareCarouselWrapper",
  "itemNavArrow": "CompareCarousel-module-scss-module__uDSTdG__itemNavArrow",
  "itemNavArrowIcon": "CompareCarousel-module-scss-module__uDSTdG__itemNavArrowIcon",
});
